import React, { Component, lazy, Suspense } from 'react';
import { Link } from 'react-router-dom';

import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';

import PageHelmet from '../component/common/Helmet';

const AboutHeader = lazy(() => import('../component/header/AboutHeader'));
const Breadcrumb = lazy(() => import('../elements/common/Breadcrumb'));
const TeamCore = lazy(() => import('../blocks/team/TeamCore'));
const MainFooter = lazy(() => import('../component/footer/MainFooter'));
const renderLoader = () => <p>Loading</p>;

class About extends Component {
  render() {
    let history =
      'Founded in 2020 with a vision to become the premier Ag-Tech company, AirNex provides services through drones, remote sensing, computer vision, customized software & data science to help nurture and support, for improved management of farms and lands. AirNex originated from its deepest desire to create products and services of exceptional value for its customers that in turn would lead to an enhanced ecological balance, improved sustainability, optimum integration of inputs and optimum outputs.';

    return (
      <React.Fragment>
        <PageHelmet pageTitle="About" />

        <Suspense fallback={renderLoader()}>
          <AboutHeader />
        </Suspense>

        <Suspense fallback={renderLoader()}>
          <Breadcrumb title={'Airnex - Expert in Geospatial Technology'} />
        </Suspense>

        {/* Start About Area  */}
        <div className="rn-about-area ptb--120 bg_color--1">
          <div className="rn-about-wrapper">
            <div className="container">
              <div className="row row--35 align-items-center">
                <div className="col-lg-12">
                  <div className="about-inner inner">
                    <div className="section-title text-center service-style--3 mb--30">
                      <h2 className="title"> Our History </h2>
                      <p className="description" style={{ color: 'black' }}>
                        {history}
                      </p>
                      {/* <h2 className="title"> Our Story </h2>
                      <p className="description" style={{ color: 'black' }}>
                        {story}
                      </p> */}
                    </div>

                    <div className="row mt--30">
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="about-us-list">
                          <h3 className="title"> Who we are </h3>
                          <p style={{ color: 'black' }}>
                            AirNex is a Drone, Satellite, Internet of Things and
                            Data based technology services provider specializing
                            in Agriculture sector with scope applicable and
                            stretching to sectors such as Civil &
                            Infrastructure, Survey & Mapping, Mining, Utilities,
                            Industrial Management and Environment. We offer the
                            following services like.
                          </p>
                          <br />
                          <br />
                          <p>• Intelligent Aerial UAV Spray</p>
                          <p>• Intelligent Aerial UAV Spreading</p>
                          <p>• Health Monitoring of Crops</p>
                          <p>• Land Survey & Mapping</p>
                          <p>• Data Services</p>
                        </div>
                      </div>
                      <div className="col-lg-6 col-md-12 col-sm-12 col-12">
                        <div className="about-us-list">
                          <h3 className="title"> What can we do? </h3>
                          <p style={{ color: 'black' }}>
                            We provide technology based aerial & remote
                            solutions for enriched management of farms and
                            lands. Data acquisition from remote site is
                            processed, analyzed and a decision support mechanism
                            is transmitted to the client for actionable
                            intelligence to either employ further AirNex
                            services and products or elect a conventional
                            approach to sort the matter.
                            <br />
                            <br />
                            <p>• Manage your farms remotely</p>
                            <p>• UAV Technology & RS application</p>
                            <p>
                              • Internet of Things & Artificial Intelligence
                            </p>
                            <p>• Customized software, portal and apps</p>
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* End About Area  */}

        {/* Start Team Area  */}
        <div className="rn-team-area bg_color--1 ptb--120">
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title service-style--3 text-center mb--25">
                  <h2 className="title"> Skilled Team </h2>
                  <p style={{ color: 'black', width: '100%' }}>
                    Founded in 2020, we cater to the technological requirements
                    of the GNSS and geospatial industry. The formation of the
                    company was realized to introduce the latest advancement in
                    geospatial technology in a range of sectors with high
                    standards and economical cost. With an amalgamation of
                    expertise in remote sensing, aerial surveillance,
                    data-management, information & technology, ergonomics and
                    artificial intelligence, we make it happen for you when it
                    comes to geo-spatial services and applications.
                  </p>
                </div>
              </div>
            </div>
            <div className="row">
              <Link to="/teams">
                <Suspense fallback={renderLoader()}>
                  <TeamCore
                    column="col-lg-3 col-md-6 col-sm-6 col-12"
                    teamStyle="team-style--bottom"
                    item="4"
                  />
                </Suspense>
              </Link>
            </div>
          </div>
        </div>
        {/* End Team Area  */}

        {/* Start Back To Top */}
        <div className="backto-top">
          <ScrollToTop showUnder={160}>
            <FiChevronUp />
          </ScrollToTop>
        </div>
        {/* End Back To Top */}

        <Suspense fallback={renderLoader()}>
          <MainFooter />
        </Suspense>
      </React.Fragment>
    );
  }
}
export default About;
